import React from 'react';
import Skeleton from 'react-loading-skeleton';
// import { LazyImage } from "react-lazy-images";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


export default class ArticleImg extends React.Component {
  render() {
    // console.log(this.props)
    const {scrollPosition} = this.props;
    return (
      <LazyLoadImage
        alt={this.props.title}
        effect="blur"
        src={this.props.image_url} 
        scrollPosition={scrollPosition}
        delayMethod='debounce'
        height={this.props.height}
        beforeLoad={() => (
          console.log('load')
          
        )}
        
      />
    
     
    );
  }
}

